var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgQuestionMark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "E7CE29B7-75A2-496E-9481-31822D929ECB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.290222 0 0 0 0 0.290175 0 0 0 0 0.290237 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "question-mark",
    transform: "translate(-165.000000, -127.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.000000, 127.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4210723,5.97405957 C15.5624303,5.53633192 13.6056843,5.97413777 12.1107972,7.16219007 C10.6291816,8.33685663 9.76745035,10.1256181 9.77228034,12.0163858 C9.77228034,12.8185696 10.4225992,13.4688681 11.224783,13.4688681 C12.0269668,13.4688681 12.6772652,12.8185696 12.6772652,12.0163858 C12.6731823,10.4254105 13.8038839,9.05760189 15.3672267,8.76234198 C16.9305695,8.46708207 18.4822518,9.32828367 19.0587098,10.8111577 C19.6351678,12.2940317 19.0725722,13.9771456 17.7202837,14.8153191 C15.7707573,15.9771994 14.5617098,18.0655541 14.5248227,20.3347518 C14.5248227,21.1369356 15.1751212,21.787234 15.977305,21.787234 C16.7794888,21.787234 17.4297872,21.1369356 17.4297872,20.3347518 C17.4732697,19.0697525 18.1662203,17.9166651 19.2628199,17.284539 C21.3883047,15.9604686 22.5101408,13.4890127 22.1075738,11.0174164 C21.7050068,8.54582012 19.8568729,6.55810493 17.4210723,5.97696454 L17.4210723,5.97405957 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.977305,0 C7.15328309,0 0,7.15328309 0,15.977305 C0,24.8013268 7.15328309,31.9546099 15.977305,31.9546099 C24.8013268,31.9546099 31.9546099,24.8013268 31.9546099,15.977305 C31.9442051,7.15759652 24.7970134,0.0104048577 15.977305,0 Z M15.977305,29.0496454 C8.7576507,29.0496454 2.90496454,23.1969592 2.90496454,15.977305 C2.90496454,8.7576507 8.7576507,2.90496454 15.977305,2.90496454 C23.1969592,2.90496454 29.0496454,8.7576507 29.0496454,15.977305 C29.0416406,23.1936409 23.1936409,29.0416406 15.977305,29.0496454 L15.977305,29.0496454 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#000000",
    fillRule: "nonzero",
    cx: 15.977305,
    cy: 24.6921986,
    r: 1.45248227
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQuestionMark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/questionMark.4c7ae6cc530346012077efa485658ae5.svg";